module.exports = __webpack_public_path__ + "components/flag/static/square/cx-29187971fc68e33821f3788148a814bc.svg";